<div>
    <app-commercial-varejo-lista 
    [filtros]="filtros"
    (exibir)="selecionar($event)">
    </app-commercial-varejo-lista>
</div>